import React from 'react';
import './Projects.css';

const Projects = () => {
  const primaryProject = {
    title: 'CodeInterview',
    subtitle: 'Intelligent System for Conducting Technical Interviews with Automated Candidate Analysis',
    description:
      'A full-stack research prototype developed as part of my diploma thesis. The system integrates real-time video communication, a structured programming workspace, code execution, and automated candidate analysis based on a large language model. Candidates progress through four stages—problem understanding, solution planning, implementation, and explanation. After the interview, the system evaluates the complete submission and generates a structured advisory report containing competency scores, strengths, weaknesses, and recommendations for improvement. The system is designed to support more consistent and transparent technical evaluation while keeping the final decision under human supervision.',
    technologies: [
      'Next.js',
      'React',
      'TypeScript',
      'Convex',
      'Stream',
      'Clerk',
      'Monaco Editor',
      'Piston',
      'Gemini API',
    ],
    link: 'https://diploma-thesis-silk.vercel.app/',
    tag: 'Diploma Thesis Project',
  };

  const secondaryProjects = [
    {
      title: 'Interactive GIS Coverage Map',
      subtitle: 'RTV Slovenia',
      description:
        'A GIS-supported application for visualizing DVB-T, DAB+ and FM signal coverage across Slovenia. Coverage data is processed with Python and ArcPy, transformed from the Gauss–Krüger coordinate system to Web Mercator, and rendered through an interactive Leaflet map.',
      technologies: ['Svelte', 'Python', 'ArcPy', 'Leaflet', 'GIS'],
      link: 'https://www.rtvslo.si/oz/oddajanje',
      tag: 'Internship Project',
    },
    {
      title: 'Hello Kitty Game',
      subtitle: 'Side-scrolling platform game',
      description:
        'A side-scrolling platform game inspired by classic platformers. The player navigates colorful levels, collects items, avoids enemies, and progresses through interactive environments.',
      technologies: ['JavaScript', 'HTML', 'CSS'],
      link: 'https://super-kitty-game.onrender.com/',
      tag: 'Personal Project',
    },
  ];

  const renderProjectLink = (project) => (
    <a
      href={project.link}
      target="_blank"
      rel="noopener noreferrer"
      className="project-link"
    >
      <span>View Project</span>

      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <path d="M5 12h14M12 5l7 7-7 7" />
      </svg>
    </a>
  );

  return (
    <section className="projects" id="projects">
      <div className="projects-container">
        <div className="section-header">
          <h2 className="section-title pink-bg">PROJECTS</h2>
        </div>

        <article className="featured-project-card primary-project-card">
          <div className="featured-project-content">
            <span className="featured-tag primary-project-tag">
              {primaryProject.tag}
            </span>

            <h3 className="featured-project-title primary-project-title">
              {primaryProject.title}
            </h3>

            <p className="featured-project-subtitle">
              {primaryProject.subtitle}
            </p>

            <p className="featured-project-description primary-project-description">
              {primaryProject.description}
            </p>

            <div className="project-technologies">
              {primaryProject.technologies.map((technology) => (
                <span key={technology} className="tech-tag">
                  {technology}
                </span>
              ))}
            </div>

            {renderProjectLink(primaryProject)}
          </div>
        </article>

        <div className="secondary-projects-grid">
          {secondaryProjects.map((project) => (
            <article
              key={project.title}
              className="featured-project-card secondary-project-card"
            >
              <div className="featured-project-content">
                <span className="featured-tag">{project.tag}</span>

                <h3 className="featured-project-title">{project.title}</h3>

                <p className="featured-project-subtitle">
                  {project.subtitle}
                </p>

                <p className="featured-project-description">
                  {project.description}
                </p>

                <div className="project-technologies">
                  {project.technologies.map((technology) => (
                    <span key={technology} className="tech-tag">
                      {technology}
                    </span>
                  ))}
                </div>

                {renderProjectLink(project)}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;